namespace BuildBrandInsightsChatLink {
  export type Params = {
    chatIdentifier: string;
    isStandaloneChat: boolean;
    basePath?: string;
  };
}

export function buildBrandInsightsChatLink({
  chatIdentifier,
  isStandaloneChat,
  basePath = '/chat',
}: BuildBrandInsightsChatLink.Params) {
  const url = new URL(window.location.href);

  if (!isStandaloneChat) {
    return `${url.origin}${url.pathname}${url.search}#bi:ocid:${chatIdentifier}`;
  }

  return `${url.origin}${basePath}/${chatIdentifier}`;
}

namespace BuildKolMailTo {
  export type Params = {
    email: string;
  };
}

export function buildKolMailTo({ email }: BuildKolMailTo.Params) {
  return `mailto:${email}`;
}

export function ensureAbsoluteHref({
  url,
  defaultProtocol = '',
}: {
  url: string;
  defaultProtocol?: Protocol;
}): string {
  const startsWithProtocol = /^((?:https?|ftp)?:)\/\//.test(url);

  const isEmail = !startsWithProtocol && url.includes('@');

  if (isEmail) {
    return `mailto:${url}`;
  }

  return startsWithProtocol ? url : `${defaultProtocol}//${url}`;
}

type Protocol = 'https' | 'http' | '';